import { useMessages } from '@src/@data/utility/hooks/useMessages';
import { useInternationalization } from '../../@data/store/InternationalizationProvider';

export const BUSINESS_APP_GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=lv.chi.spendo.business';

export const GooglePlayButton: React.FC = () => {
  const { language } = useInternationalization();
  const { messages } = useMessages();

  return (
    <a
      href={BUSINESS_APP_GOOGLE_PLAY_LINK}
      rel="noopener noreferrer"
      target="_blank"
      className="flex-shrink-0 d-block"
      style={{ height: '64px' }}
    >
      <img
        src={`https://play.google.com/intl/en_us/badges/static/images/badges/${language}_badge_web_generic.png`}
        alt={messages('google_play_button_alt')}
        className="h-100"
      />
    </a>
  );
};
